var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pp-breadcrumb"},_vm._l((_vm.crumbs),function(crumb,index){return _c('span',{key:index,on:{"click":function($event){return _vm.navigate(crumb.path)}}},[_vm._v(" "+_vm._s(_vm.$t(crumb.name))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }